var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { usePrevious } from '../../hooks';
import { useIsFirstRender } from './useIsFirstRender';
import * as S from './styles';
import { useTheme } from '../../themes';
export var Skeleton = forwardRef(function (props, ref) {
    var theme = useTheme();
    var isLoaded = props.isLoaded, rest = __rest(props, ["isLoaded"]);
    var isFirstRender = useIsFirstRender();
    var wasPreviouslyLoaded = usePrevious(isLoaded);
    if (isLoaded) {
        var animation = !(isFirstRender || wasPreviouslyLoaded);
        return (_jsx(S.Container, __assign({ "data-testid": "skeleton-container", ref: ref, animation: animation }, rest)));
    }
    if (typeof rest.bgColors === 'undefined') {
        rest.bgColors = [theme.neutrals.gray1, theme.neutrals.gray4];
    }
    return _jsx(S.Skeleton, __assign({ "data-testid": "skeleton", ref: ref }, rest));
});
